import React from 'react';

export const ButtonPanel = (props) => {
  return (
    <div className={props.className}>
      { props.children }
    </div>
  )
}